export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '精品久久久是什么？',
    answer: '精品久久久是一个高品质精选内容长效平台，致力于汇聚经久不衰的优质内容与精品资源。我们通过严格的筛选机制，为追求品质生活的用户提供持久、稳定、高价值的阅读体验，涵盖生活美学、深度阅读、人物风尚、科技前沿、艺术设计、健康养生等多个领域。',
  },
  {
    question: '精品久久久的内容是如何筛选的？',
    answer: '我们的编辑团队由各领域的资深人士组成，每一篇文章都经过"三审三校"的严格流程：初审由领域编辑把关选题价值与内容质量，复审由资深主编进行深度审核，终审由总编辑确认发布标准。我们坚持"宁缺毋滥"的原则，确保每一篇内容都经得起时间的考验。',
  },
  {
    question: '如何订阅精品久久久的内容更新？',
    answer: '您可以通过多种方式订阅我们的内容：1）在网站首页底部订阅我们的电子 Newsletter，每周五会将本周精选内容发送到您的邮箱；2）关注我们的社交媒体账号，获取每日精选推送；3）将精品久久久添加到浏览器收藏夹，随时访问最新内容。',
  },
  {
    question: '精品久久久的内容更新频率是怎样的？',
    answer: '我们坚持"质量优先"的原则，每周更新3-5篇经过精心打磨的原创或精选文章。我们不追求数量上的堆砌，而是确保每一篇文章都能为读者带来真正的价值和启发。此外，我们还会定期推出专题策划和系列报道。',
  },
  {
    question: '如何联系精品久久久的编辑团队？',
    answer: '您可以通过以下方式联系我们：1）发送邮件至 contact@jingpin999.com；2）在"关于我们"页面使用在线联系表单；3）关注我们的官方社交媒体账号并发送私信。我们会在24小时内回复您的咨询。欢迎投稿、合作或提供宝贵建议。',
  },
  {
    question: '精品久久久是否有移动端应用？',
    answer: '目前我们提供完全响应式的网站体验，在手机、平板和桌面端都能获得优质的阅读体验。移动端原生应用正在开发中，预计将在今年内推出，届时将为用户提供更便捷的移动阅读功能和离线阅读支持。',
  },
  {
    question: '我可以投稿给精品久久久吗？',
    answer: '当然可以！我们欢迎各领域的优质原创内容投稿。请将您的稿件或选题提案发送至 submit@jingpin999.com，并附上您的个人简介。我们的编辑团队会在5个工作日内完成初审并回复。如果稿件被采用，我们将提供具有竞争力的稿酬和完善的作者推广支持。',
  },
];